<template>
  <div :bordered="false">
    <template v-if="this.departId">
      <a-spin :spinning="loading">
        <a-form>
          <a-form-item label=''>
            <a-tree
              checkable
              @check="onCheck"
              :checkedKeys="checkedKeys"
              :treeData="treeData"
              @expand="onExpand"
              @select="onTreeNodeSelect"
              :selectedKeys="selectedKeys"
              :expandedKeys="expandedKeysss"
              :checkStrictly="checkStrictly"
              style="height:500px;overflow: auto;">
              <span slot="hasDatarule" slot-scope="{slotTitle,ruleFlag}">
                {{ slotTitle }}
                <a-icon v-if="ruleFlag" type="align-left" style="margin-left:5px;color: red;"></a-icon>
              </span>
            </a-tree>
          </a-form-item>
        </a-form>
      </a-spin>
      <div class="anty-form-btn">
        <a-dropdown style="float: left" :trigger="['click']" placement="topCenter">
          <a-menu slot="overlay">
            <!-- 简化Tree逻辑，使用默认checkStrictly为false的行为，即默认父子关联
            <a-menu-item key="1" @click="switchCheckStrictly(1)">父子关联</a-menu-item>
            <a-menu-item key="2" @click="switchCheckStrictly(2)">取消关联</a-menu-item>
            -->
            <a-menu-item key="3" @click="checkALL">{{ $t('antd.tree.checkALL') }}</a-menu-item>
            <a-menu-item key="4" @click="cancelCheckALL">{{ $t('antd.tree.uncheckAll') }}</a-menu-item>
            <a-menu-item key="5" @click="expandAll">{{ $t('antd.tree.expandAll') }}</a-menu-item>
            <a-menu-item key="6" @click="closeAll">{{ $t('antd.tree.closeAll') }}</a-menu-item>
          </a-menu>
          <a-button>
            {{ $t('antd.tree.operation') }} <a-icon type="up" />
          </a-button>
        </a-dropdown>
        <a-button style="float: right" @click="handleSubmit" type="primary" htmlType="button" icon="form">保存</a-button>
      </div>
    </template>
    <!-- <depart-datarule-modal ref="datarule"/> -->
  </div>
</template>

<script>
  import { roleGet, roleMenuUpdate } from '@/api/app'
   import { mapState } from 'vuex'
  // import DepartDataruleModal from './DepartDataruleModal'

  export default {
    name: 'DepartAuthModal',
    // components: { DepartDataruleModal },
    data(){
      return {
        departId:"",
        treeData: [],
        defaultCheckedKeys:[],
        checkedKeys:[],
        halfCheckedKeys:[],
        expandedKeysss:[],
        allTreeKeys:[],
        autoExpandParent: true,
        checkStrictly: false,
        title: this.$t('system.character.treeTitle'),
        visible: false,
        loading: false,
        selectedKeys:[]
      }
    },
    computed: {
      ...mapState({
        // 后台菜单
        permissionMenuList: state => state.user.permissionList

      })
    },
    methods: {
      onTreeNodeSelect(id){
        if(id && id.length>0){
          this.selectedKeys = id
        }
        this.$refs.datarule.show(this.selectedKeys[0],this.departId)
      },
      onCheck (checkedKeys, { halfCheckedKeys }) {
        // 保存选中的和半选中的，后面保存的时候合并提交
        this.checkedKeys = checkedKeys
        this.halfCheckedKeys = halfCheckedKeys
      },
      show(departId){
        this.departId = departId
        this.loadData();
      },
      close () {
        this.reset()
        this.$emit('close');
        this.visible = false;
      },
      onExpand(expandedKeys){
        this.expandedKeysss = expandedKeys;
        this.autoExpandParent = false
      },
      reset () {
        this.expandedKeysss = []
        this.checkedKeys = []
        this.defaultCheckedKeys = []
        this.loading = false
      },
      expandAll () {
        this.expandedKeysss = this.allTreeKeys
      },
      closeAll () {
        this.expandedKeysss = []
      },
      checkALL () {
        this.checkedKeys = this.allTreeKeys
      },
      cancelCheckALL () {
        this.checkedKeys = []
      },
      handleCancel () {
        this.close()
      },
      handleSubmit() {
        let that = this;
        if(!that.departId){
          this.$message.warning(this.$t('system.character.pleaseSelectDepart'))
        }
        let checkedKeys = [...that.checkedKeys]
        console.log("------ ", that.checkedKeys, that.halfCheckedKeys)
        let params =  {
          id:that.departId,
          menuList: [...new Set(checkedKeys)],
        };
        that.loading = true;
        roleMenuUpdate(params).then((res)=>{
          if(res.code == "200"){
            that.$message.success(res.msg);
            that.loading = false;
            that.loadData();
          }else {
            that.$message.error(res.msg);
            that.loading = false;
          }
        })
      },
      convertTreeListToKeyLeafPairs(treeList, keyLeafPair = []) {
        for(const {id, children, parentId} of treeList) {
          if(parentId){
            keyLeafPair.push({key: id, isLeaf:true})
          }else{
            keyLeafPair.push({key: id, isLeaf:false})
          }
         
          if(children && children.length > 0) {
            this.convertTreeListToKeyLeafPairs(children, keyLeafPair)
          }
        }
        return keyLeafPair;
      },
      convertTreeListAllTreeKeys(treeList, keyLeafPair = []){
        for(const {id, children} of treeList) {
          keyLeafPair.push(id)
          if(children && children.length > 0) {
            this.convertTreeListAllTreeKeys(children, keyLeafPair)
          }
        }
        return keyLeafPair;
      },
      convertTreeFramData(dataTree, childNode = 'children'){
        let newTreeNode = []
        dataTree.forEach((item)=> {
            item.key = item.id
            if(!item[childNode] ||item[childNode].length <= 0){
                delete item[childNode]
                newTreeNode.push(item)
            }else{
              this.convertTreeFramData(item[childNode], childNode)
              newTreeNode.push(item)
            }
        })
        return newTreeNode
      },
      emptyCurrForm() {
        this.form.resetFields()
      },
      loadData(){
          this.loading = true;
          this.treeData = this.convertTreeFramData(JSON.parse(JSON.stringify(this.permissionMenuList)))
          this.allTreeKeys = this.convertTreeListAllTreeKeys(this.treeData)
          const keyLeafPairs = this.convertTreeListToKeyLeafPairs(this.treeData)
          roleGet({id:this.departId}).then((res)=>{
            // 过滤出 leaf node 即可，即选中的
            // Tree组件中checkStrictly默认为false的时候，选中子节点，父节点会自动设置选中或半选中
            // 保存 checkedKeys 以及 halfCheckedKeys 以便于未做任何操作时提交表单数据
            const filtTreeData = this.convertTreeFramData(JSON.parse(JSON.stringify(res.data.menuList)))
            const allTreeKeys = this.convertTreeListAllTreeKeys(filtTreeData)

            console.log(filtTreeData, res.data.menuList, allTreeKeys)
            if(allTreeKeys.length){
              const checkedKeys = [...allTreeKeys].filter(key => {
                const keyLeafPair = keyLeafPairs.filter(item => item.key === key)[0]
                return keyLeafPair && keyLeafPair.isLeaf
              })

              const halfCheckedKeys = [...allTreeKeys].filter(key => {
                const keyLeafPair = keyLeafPairs.filter(item => item.key === key)[0]
                return keyLeafPair && !keyLeafPair.isLeaf
              })
              this.checkedKeys = [...checkedKeys];
              this.halfCheckedKeys = [...halfCheckedKeys]
              this.defaultCheckedKeys = [...halfCheckedKeys, ...checkedKeys];
            }
            
            this.expandedKeysss = this.allTreeKeys;
            this.loading = false;
          })
      
      }
    },
  }
</script>

<style scoped>
.anty-form-btn{
   position: absolute;
          right: 0;
          bottom: 0;
          width: 100%;
          border-top: 1px solid #e9e9e9;
          padding: 10px 16px;
          background: #fff;
          text-align: right;
          z-index: 1
}
</style>